import { render, staticRenderFns } from "./PanelAffirmation.vue?vue&type=template&id=90f6ea12&"
import script from "./PanelAffirmation.vue?vue&type=script&lang=js&"
export * from "./PanelAffirmation.vue?vue&type=script&lang=js&"
import style0 from "./PanelAffirmation.vue?vue&type=style&index=0&id=90f6ea12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports